import { ButtonTertiary } from "@nova/component-btn"
import { Dropdown } from "@nova/component-dropdown"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { ButtonSplit } from "@nova/ds-component-button-split"
import { useMemo, useState } from "react"
import { useAircraft } from "../aircraft/AircraftQueries"
import { getDisplayableAircraftData } from "@nova/constants"
import classNames from "classnames"

export interface DroneFilterValue {
    id: string
    name: string
}

interface DroneFilterProps {
    value: DroneFilterValue | undefined
    onChange: (value: DroneFilterValue | undefined) => void
}

export const UNASSIGNED: DroneFilterValue = { id: "unassigned", name: "Unassigned" }

export const DroneFilter = ({ value, onChange }: DroneFilterProps) => {
    const [search, setSearch] = useState("")

    const { aircraft } = useAircraft()

    const filtered = useMemo(
        () =>
            aircraft.filter((a) => {
                const { displayName } = getDisplayableAircraftData(a)
                return displayName.toLowerCase().includes(search.toLowerCase())
            }),
        [aircraft, search]
    )

    return (
        <Dropdown>
            <Dropdown.Trigger as="div" className="group">
                {value ? (
                    <ButtonSplit
                        label={value.name}
                        onRightClick={(e) => {
                            e.stopPropagation()
                            onChange(undefined)
                        }}
                    />
                ) : (
                    <ButtonTertiary
                        title="Drone"
                        RightIcon={Icons.ArrowDropdown}
                        rightIconClassName="transition-transform group-data-[state=open]:rotate-180"
                        className="group-data-[state=open]:!border-gray-300 group-data-[state=open]:!text-gray-0"
                    />
                )}
            </Dropdown.Trigger>
            <Dropdown.Menu className="w-[300px] text-gray-100">
                <div className="p-3 pb-2">
                    <InputOutlined
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        placeholder="Search for a drone"
                        leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
                        autoFocus
                    />
                </div>
                <ScrollableArea className="max-h-[300px]">
                    {filtered.map((a) => {
                        const { displayName } = getDisplayableAircraftData(a)
                        return (
                            <Dropdown.ButtonItem
                                key={a.id}
                                onClick={() => onChange({ id: a.id, name: displayName })}
                                className={classNames("flex items-center px-4 py-2.5", {
                                    "bg-white-200": value?.id === a.id,
                                })}
                            >
                                <span className="text-sm text-white">{displayName}</span>
                            </Dropdown.ButtonItem>
                        )
                    })}
                </ScrollableArea>
                <div className="w-full h-px bg-white-200 my-1" />
                <Dropdown.ButtonItem
                    onClick={() => onChange(UNASSIGNED)}
                    className="flex items-center px-4 py-2.5"
                >
                    <span className="text-sm text-white">{UNASSIGNED.name}</span>
                </Dropdown.ButtonItem>
            </Dropdown.Menu>
        </Dropdown>
    )
}
